import { useDispatch, useSelector } from "react-redux";
import {
  NavigationItem,
  SoonContainer,
  TabsContainer,
} from "./TabsComponent.styles";
import { NavLink, useLocation } from "react-router-dom";
import {
  clearExploreCollections,
  selectCategories,
  setSelectedExploreCollectionFilter,
} from "../../../store/slices/model/slice";

const TABS = [
  { name: "Explore", path: "/" },
  { name: "Collection", path: "/collection" },
  { name: "Train", path: "/train", soon: false },
];

const TabsComponent = ({ hidden }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isExplorePage = location.pathname === "/";
  const { data: categories } = useSelector(selectCategories);

  return (
    <TabsContainer $hidden={hidden}>
      {TABS.map((tab) => {
        return (
          <NavigationItem key={tab.path}>
            <NavLink
              to={tab.path}
              onClick={(el) => {
                if (tab.path === "/" && isExplorePage) {
                  dispatch(clearExploreCollections());
                  dispatch(
                    setSelectedExploreCollectionFilter(categories[0]._id)
                  );

                  setTimeout(() => {
                    window.scrollTo(0, 0);
                  }, 300);
                }

                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "instant",
                });
              }}
            >
              <p>{tab.name}</p>
            </NavLink>
            {tab.soon && <SoonContainer>SOON</SoonContainer>}
          </NavigationItem>
        );
      })}
    </TabsContainer>
  );
};

export default TabsComponent;
